import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LADDER_LATER, LADDER_TODAY } from '../../data/walkthrough.fixtures';

/**
 * Pane 8 / 8 — `Growing with you` (specs/auth.md §5.4).
 *
 * The last pane, and therefore the one where the footer's primary button flips
 * from `Next` to `Create my workspace`. That flip belongs to the shell, not
 * here — this component does not know it is last.
 *
 * Two bespoke pieces: the Today/Later ladder and a quoted AI prompt.
 *
 * ⚠ THE PROMPT IS NOT MONEY. `above 50,000.` / `au-delà de 50 000.` is a
 * sentence somebody typed, quoted inside a bordered box, and it does NOT go
 * through `| kzMoney` (spec §8, §11 R6). English groups with a comma and curly
 * double quotes; French uses guillemets and a space. Formatting it would put
 * XAF grouping rules inside a person's speech, and there is no amount and no
 * currency here for the pipe to be right about.
 *
 * The third bullet also breaks the pattern: a `sparkles` glyph in primary
 * rather than a success tick, because it is the one bullet describing something
 * that does not exist yet. The source states that with an inline `style`; here
 * it is `--soon`, so the exception has a name.
 */
@Component({
  selector: 'app-walkthrough-pane8',
  standalone: false,
  templateUrl: './walkthrough-pane8.component.html',
  styleUrls: ['./walkthrough-pane8.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane8Component {
  readonly today = LADDER_TODAY;
  readonly later = LADDER_LATER;
}
